import { isValidSpanId } from './IsValidSpanId.js';
import { isValidTraceId } from './IsValidTraceId.js';

// Заголовок traceparent версии 00 с флагом sampled: `00-<traceId>-<spanId>-01`.
export function buildTraceparent(traceId: string, spanId: string): string {
  if (!isValidTraceId(traceId)) {
    throw new Error(`Invalid traceId: ${traceId}`);
  }
  if (!isValidSpanId(spanId)) {
    throw new Error(`Invalid spanId: ${spanId}`);
  }
  return `00-${traceId}-${spanId}-01`;
}
